module.exports = "/packs/images/svg/facilities/pitches~fdc393d1229b9cae6ffa14f8511c0735.svg";